module.exports = __webpack_public_path__ + "static/media/Food7.35bc12ce.jpg";